import React, { useEffect } from "react"
import { Table } from "react-bootstrap"
import { useKonva } from "../../context/KonvaContext"

const SuggestionTable = () => {
    const {
        suggestDimension,
        setSelectedDimension,
        setSelectedSuggestionIndex,
        selectedDimension,
        setSelectedDimensionHistory
    } = useKonva()


    const handleSuggestionChange = (suggestion, index) => {
        setSelectedDimension(suggestion)
        setSelectedSuggestionIndex(index)
    }

    useEffect(() => {
        let choosedDimesion = null
        if (suggestDimension.length === 1) {
            setSelectedDimension(suggestDimension[0])
            choosedDimesion = suggestDimension[0]
        } else {
            choosedDimesion = suggestDimension?.find(({ id }) => id === selectedDimension?.id)
        }

        if (choosedDimesion) {
            setSelectedDimensionHistory(choosedDimesion)
        }
        
    }, [suggestDimension, setSelectedDimension, selectedDimension,setSelectedDimensionHistory])

    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>No.</th>
                    <th>Select</th>
                    <th>Direction 1 & Direction 2</th>
                    <th>Area (squarefeet)</th>
                </tr>
            </thead>
            <tbody>
                {suggestDimension.map((suggestion, index) => (
                    <tr key={suggestion.id}>
                        <td>{index + 1}</td>
                        <td><input type='radio' name='selectedSuggestion' defaultChecked={(suggestDimension.length === 1 || suggestion?.checked) ?? false} onChange={() => handleSuggestionChange(suggestion, index)} /></td>
                        <td>{`Width=${suggestion?.originalWidth} & Height =${suggestion?.height}`}</td>
                        <td>{suggestion?.area}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

export default SuggestionTable